// this is needed in order for webpack to do its thing, without this twse and twdk versions wont work
export default function HeaderSpecialLinks() {
	return null;
}
